import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from 'contexts/AuthContext';
import GlobalStyle from 'styles/globalStyle';
import theme from 'styles/theme';
import { ThemeProvider } from 'styled-components';
import { channelTalkService } from 'utils';
import ReactGa from 'react-ga4';
import { AxiosError } from 'axios';
import { TOAST_ERROR_STATUS } from 'apis/errorHandler';

import 'pretendard/dist/web/variable/pretendardvariable.css';
import 'pretendard/dist/web/static/pretendard.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './index.css';

import * as logsUtils from 'utils/logsUtils';
import App from './App';
import reportWebVitals from './reportWebVitals';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retryOnMount: false,
      retry: (failureCount, error) => {
        const errorStatus = ((error as AxiosError)?.response?.data as any)?.status;
        // 권한 없음 등 재시도해도 결과가 같은 비즈니스 에러는 즉시 중단
        if (TOAST_ERROR_STATUS.includes(errorStatus)) {
          return false;
        }
        return failureCount < 3;
      }
    },
    mutations: {
      retry: (failureCount, error) => {
        if (failureCount > 2) {
          return false;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorStatus = ((error as AxiosError)?.response?.data as any)?.status;
        if (failureCount >= 0 && errorStatus) {
          return (error as AxiosError)?.response?.status === 401;
        }
        return true;
      }
    }
  }
});
channelTalkService.loadScript();

const gaId = process.env.NODE_ENV === 'development' ? 'G-F8YPFY6NB2' : 'G-GD4B0DESK1';
// 첫 화면 page_view는 App이 user_id와 함께 보낸다 - config 기본 전송까지 나가면 2건이 된다
ReactGa.initialize([{ trackingId: gaId, gtagOptions: { send_page_view: false } }]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

logsUtils.datadogLogsInit();
